import { render, staticRenderFns } from "./OrderEvaluation.vue?vue&type=template&id=1f3fae68&scoped=true"
import script from "./OrderEvaluation.vue?vue&type=script&lang=js"
export * from "./OrderEvaluation.vue?vue&type=script&lang=js"
import style0 from "./OrderEvaluation.vue?vue&type=style&index=0&id=1f3fae68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3fae68",
  null
  
)

export default component.exports